import { render, staticRenderFns } from "./MovieView.vue?vue&type=template&id=1bc11d86&scoped=true&"
import script from "./MovieView.vue?vue&type=script&lang=js&"
export * from "./MovieView.vue?vue&type=script&lang=js&"
import style0 from "./MovieView.vue?vue&type=style&index=0&id=1bc11d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc11d86",
  null
  
)

export default component.exports